import React, {useState} from 'react';
import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {DeleteForever, Edit, MoreHoriz} from "@mui/icons-material";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";

const MenuFontColorSecondaryDarkDeleteForever = styled(DeleteForever)(({theme}) => ({
  color: theme.palette.secondary.dark
}));

const MenuFontColorSecondaryDarkEdit = styled(Edit)(({theme}) => ({
  color: theme.palette.secondary.dark
}));

const MenuMinWidthAuto = styled(ListItemIcon)(() => ({
  minWidth: 'auto'
}));

const MenuColumnGap8 = styled(MenuItem)(() => ({
  columnGap: '0.57rem',
}));

const PaymentMethodsActionsMenu = ({ onSelect, disableRemove = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const iconRef = React.useRef(null);

  const onIconClick = () => {
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleSelect = (value) => {
    setMenuOpen(false);
    onSelect(value);
  };

  return (
    <>
      <IconButton
        onClick={onIconClick}
        aria-haspopup={true}
        aria-controls={'ss-payment-actions'}
        ref={iconRef}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        id={'ss-payment-actions'}
        anchorEl={iconRef.current}
        open={menuOpen}
        onClose={handleCloseMenu}
        keepMounted
      >
        {
          !disableRemove && <MenuColumnGap8 onClick={() => handleSelect('remove')}>
            <MenuMinWidthAuto>
              <MenuFontColorSecondaryDarkDeleteForever fontSize={'small'}/>
            </MenuMinWidthAuto>
            <ListItemText
              primary={'Remove'}
              primaryTypographyProps={{
                variant: 'subtitle2',
                color: 'secondary'
              }}
            />
          </MenuColumnGap8>
        }
        <MenuColumnGap8 onClick={() => handleSelect('rename')}>
          <MenuMinWidthAuto>
            <MenuFontColorSecondaryDarkEdit fontSize={'small'} />
          </MenuMinWidthAuto>
          <ListItemText
            primary={'Rename'}
            primaryTypographyProps={{
              variant: 'subtitle2',
              color: 'secondary'
            }}
          />
        </MenuColumnGap8>
      </Menu>
    </>
  );
};

PaymentMethodsActionsMenu.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disableRemove: PropTypes.bool,
};

export default PaymentMethodsActionsMenu;
